import { render, staticRenderFns } from "./limit-wrap.vue?vue&type=template&id=135d26aa&scoped=true"
import script from "./limit-wrap.vue?vue&type=script&lang=js"
export * from "./limit-wrap.vue?vue&type=script&lang=js"
import style0 from "./limit-wrap.vue?vue&type=style&index=0&id=135d26aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d26aa",
  null
  
)

export default component.exports